<template>
  <div class="dialog-wrap">
    <el-dialog
      title="院校添加"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      @close="handleClose"
      width="480px">
      <el-form class="form" :model="dataForm" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="院校名称" prop="name">
          <el-input v-model="dataForm.name" placeholder="请输入院校名称"></el-input>
        </el-form-item>
        <el-form-item label="院校代码" prop="code">
          <el-input v-model="dataForm.code" placeholder="请输入院校代码，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="院校标志" prop="logo">
          <el-upload
            class="cover-uploader"
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="handleBeforeUpload">
            <img v-if="dataForm.logo" :src="dataForm.logo" class="cover">
            <i v-else class="el-icon-plus cover-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="地区" prop="province_code">
          <el-select v-model="dataForm.province_code" placeholder="请选择院校归属地区" style="width: 100%;">
            <el-option
              v-for="item in provinces"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="院校分类" prop="category_id">
          <el-select v-model="dataForm.category_ids" multiple placeholder="请选择科目分类" style="width: 100%;">
            <el-option
              v-for="item in categorys"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="排序值" prop="sort">
          <el-input v-model="dataForm.sort" placeholder="请输入排序值，纯数字"></el-input>
        </el-form-item>
        <el-form-item label="在线状态" prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { collegeCreate, collegeCategoryList } from '@/api/common'
import { imgUploadUrl, uploadHeaders } from '@/config/index'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    provinces: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        logo: ''
      },
      categorys: [],
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      rules: {
        name: [{ required: true, message: '请输入院校名称', trigger: 'blur' }],
        code: [{ required: true, message: '请输入院校代码，纯数字', trigger: 'blur' }],
        logo: [{ required: false, message: '请上传院校标志', trigger: 'blur' }],
        province_code: [{ required: true, message: '请选择院校归属地区', trigger: 'change' }],
        sort: [{ required: true, message: '请输入排序值，纯数字', trigger: 'blur' }],
        status: [{ required: false, message: '请设置上线状态', trigger: 'change' }]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
      if (val) {
        this.fetchCategoryList()
      }
    }
  },
  methods: {
    fetchCategoryList() {
      collegeCategoryList({isPaging: 0}).then(res => {
        this.categorys = res.list
      })
    },
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const params = Object.assign({}, this.dataForm,
            {status:  this.dataForm.status ? 1 : 0},
            {category_ids: this.dataForm.category_ids ? this.dataForm.category_ids.join(',') : ''}
          )
          collegeCreate(params).then(res => {
            this.$message.success(`添加成功`)
            this.$refs['dataForm'].resetFields()

            this.$emit('submit')
            this.handleClose()
          }).catch(error => {
            console.log('error: ', error)
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
    handleUploadSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.dataForm.icon = res.data.url
      } else {
        this.$message.error(res.error)
      }
    },
    handleBeforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 2MB!')
      }
      return isLt2M
    },
  }
}
</script>

<style lang="less" scoped>
  .dialog-wrap {

    .form {
      margin-bottom: -18px;

      .cover-uploader /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .cover-uploader /deep/ .el-upload:hover {
        border-color: #409EFF;
      }
      .cover-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 128px;
        height: 128px;
        line-height: 128px;
        text-align: center;
      }
      .cover {
        display: block;
        width: 128px;
        height: 128px;
        object-fit: cover;
      }
    }
  }
</style>
